import { UserRole } from '@shared/models';

import { Language } from '@/organisations/models';
import { PersonalTaxFile } from '@/tax/models';

export class User {
    id = -1;
    email = '';
    emailVerified = false;
    firstName = '';
    lastName = '';
    isActive = false;
    dateJoined?: Date;
    lastLogin?: Date;
    phoneNumber = '';
    avatarUrl = '';
    roles: UserRole[] = [];
    updateAvatar?: File;
    isStaff = false;
    locale = Language.NL as string;

    deserialize(data: any): this {
        this.id = data.id;
        this.email = data.email;
        this.emailVerified = data.email_verified;
        this.firstName = data.first_name;
        this.lastName = data.last_name;
        this.isActive = data.is_active;
        this.dateJoined = new Date(data.date_joined);
        this.lastLogin = new Date(data.last_login);
        this.phoneNumber = data.phone_number;
        this.avatarUrl = data.avatar;
        this.roles = data.roles?.map((object: any) => new UserRole().deserialize(object)) ?? [];
        this.isStaff = data.is_staff;
        this.locale = data.locale ?? Language.NL;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            email_verified: this.emailVerified,
            first_name: this.firstName,
            last_name: this.lastName,
            is_active: this.isActive,
            last_login: this.lastLogin?.toISOString() ?? '',
            date_joined: this.dateJoined?.toISOString() ?? '',
            email: this.email,
            phone_number: this.phoneNumber,
            roles: this.roles.map((r) => r.serialize()),
            avatar: this.updateAvatar,
            locale: this.locale,
        };
    }

    isCompanyManagerByIds(orgId: number, companyId: number): boolean {
        return (
            this.roles
                .filter((role) => role.organisationId === orgId)
                .some((role) => role.fullCompanyAccess || role.managedCompanies.includes(companyId)) ?? false
        );
    }

    isCompanyManager(file: PersonalTaxFile): boolean {
        return this.isCompanyManagerByIds(file.organisation, file.company.id);
    }

    isCompanyViewer(orgId: number, companyId: number): boolean {
        return (
            this.roles
                .filter((role) => role.organisationId === orgId)
                .some((role) => role.fullCompanyAccess || role.companies.includes(companyId)) ?? false
        );
    }
}
